import useHelpers from "composables/useHelpers.js";
import axios from "axios";
import { DEFAULT_SUCCESS_CRITERIA } from "models/learning-objectives/learningObjectivesConstants";
import { EventEmitter } from "models/EventEmitter.js";

export class SuccessCriteria {
  constructor(data = {}) {
    this.id = data.id ?? DEFAULT_SUCCESS_CRITERIA.id;
    this.order = data.order ?? DEFAULT_SUCCESS_CRITERIA.order;
    this.name = data.name ?? DEFAULT_SUCCESS_CRITERIA.name;
    this.teacher_hints =
      data.teacher_hints ?? DEFAULT_SUCCESS_CRITERIA.teacher_hints;
    this.attachments = data.attachments ?? DEFAULT_SUCCESS_CRITERIA.attachments;
    this.links = data.links ?? DEFAULT_SUCCESS_CRITERIA.links;
    this.videos = data.videos ?? DEFAULT_SUCCESS_CRITERIA.videos;
    this.meta = data.meta ?? DEFAULT_SUCCESS_CRITERIA.meta;
    this.is_temporary = !data.library_learning_objective_id;
    this.library_learning_objective_id =
      data.library_learning_objective_id ??
      DEFAULT_SUCCESS_CRITERIA.library_learning_objective_id;
    this.events = new EventEmitter();
  }

  onDelete(callback) {
    this.events.on("deleted", callback);
  }

  async add() {
    const { schoolId, rewriteModelToFormData } = useHelpers();
    const { library_learning_objective_id } = this;

    const formData = rewriteModelToFormData(this);

    const {
      data: { data: storedSuccessCriteria },
    } = await axios.post(
      `api/school/${schoolId}/library-learning-objectives/${library_learning_objective_id}/library-success-criteria`,
      formData,
    );

    this.is_temporary = false;

    Object.assign(this, storedSuccessCriteria);

    return this;
  }

  async update(data) {
    const { schoolId, rewriteModelToFormData } = useHelpers();

    const formData = rewriteModelToFormData(data);
    formData.set("_method", "PUT");

    const {
      data: { data: storedSuccessCriteria },
    } = await axios.post(
      `/api/school/${schoolId}/library-learning-objectives/${this.library_learning_objective_id}/library-success-criteria/${this.id}`,
      formData,
    );

    Object.assign(this, storedSuccessCriteria);

    return storedSuccessCriteria;
  }

  async upsert(data) {
    try {
      if (this.library_learning_objective_id === null && this.is_temporary) {
        // New success criteria without in a new learning objective so only update the temporary one
        Object.assign(this, data);
        return this;
      }

      if (this.is_temporary) {
        await this.add();
        return this;
      }

      if (this.id) {
        await this.update(data);
        return this;
      }
    } catch (error) {
      console.log("Error in upsert:", error);
    }
  }

  async remove() {
    try {
      if (!this.is_temporary) {
        const { schoolId } = useHelpers();
        const { id, library_learning_objective_id } = this;

        await axios.delete(
          `api/school/${schoolId}/library-learning-objectives/${library_learning_objective_id}/library-success-criteria/${id}`,
        );
      }

      this.events.emit("deleted", this);
    } catch (error) {
      throw new Error(error);
    }
  }
}
